export const css = {
    root: '_3l1KswYZ',
    input: '_3-kBpmDG',
    toggleCalendarButton: '_3gxRvpxw',
    popup: '_3WwUDA0K',
    ' _key': 'apic-theme/dojo/date-input'
};
export default css;
